import { NgModule } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { RouterModule, Routes, PreloadAllModules, PreloadingStrategy, Route } from '@angular/router';
import { LoginComponent } from './screens/authentications/login/login.component';
import { PublicLayoutComponent } from './shared/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './shared/private-layout/private-layout.component';
import { AuthGuard } from './services/auth.guard';
import { SignUpComponent } from './screens/authentications/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './screens/authentications/forgot-password/forgot-password.component';
// import { QualityAnalysisComponent } from './screens/quality-analysis/quality-analysis.component';
// import { SafetyDbComponent } from './screens/safety-db/safety-db.component';
import { DashboardComponent } from './screens/dashboard/dashboard.component';
// import { QualityDbComponent } from './screens/quality-db/quality-db.component';
// import { AvailabilityAnalysisComponent } from './screens/availability-analysis/availability-analysis.component';
// import { CuAnalysisComponent } from './screens/cu-analysis/cu-analysis.component';
// import { DefectConfigurationComponent } from './O3AdministrationComponents/ManufacturingAdminComponents/defect-configuration/defect-configuration.component';
// import { DefectManagementMasterComponent } from './DMS/defect-management-master/defect-management-master.component';
import { CustomerComplaintComponent } from './customer-complaint/customer-complaint.component';
// import { CcrHistoryComponent } from './ccr-history/ccr-history.component';
// import { OrgTreeComponent } from './KPIs Management/OrgTree/OrgTree.component';
import { MeetingEvaluationComponent } from './meeting-evaluation/meeting-evaluation/meeting-evaluation.component';
import { DatetestComponent } from './datetest/datetest.component';
import { MeetingEvaluationLevelComponent } from './meeting-evaluation/meeting-evaluation-level/meeting-evaluation-level.component';
import { NewSfdcHoneyComponent } from './ProductionOrderComponents/new-sfdc-honey/new-sfdc-honey.component';
// OPMS-Glass
// import { OPMSMainComponent } from './OPMS-Glass/opms-main/opms-main.component';
// import { OpmsDataComponent } from './OPMS-Glass/opms-data/opms-data.component';
// import { OpmsDailyConsuptionComponent } from './OPMS-Glass/opms-daily-consuption/opms-daily-consuption.component';
// import { OpmsMonthlyStockComponent } from './OPMS-Glass/opms-monthly-stock/opms-monthly-stock.component';
// import { OpmsBoxReceivingComponent } from './OPMS-Glass/opms-box-receiving/opms-box-receiving.component';

import { QCBoxComponent } from './ProductionOrderComponents/QC-Box/QC-Box.component';
import { QaDataEntryComponent } from './Quality-ODS/qa-data-entry/qa-data-entry.component';
import { ConfirmEmailComponent } from './static/confirm-email/confirm-email.component';
import { SharedConstants } from './user-management/shared/models/shared-constants';
import { LandingPageComponent } from './screens/landing-page/landing-page.component';
import { NewSfdcComponent } from './ProductionOrderComponents/new-sfdc/new-sfdc.component';
import { Observable, of } from 'rxjs';
import { PageNotFoundComponent } from './screens/authentications/page-not-found/page-not-found.component';
import { HandsfreeOperatorComponent } from './ProductionOrderComponents/handsfree-operator/handsfree-operator.component';
import { ResetPasswordComponent } from './screens/authentications/reset-password/reset-password.component';

class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}


const routes: Routes = [
  // Private layout
  {
    path: '',
    // runGuardsAndResolvers: 'always',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'logout', component: LoginComponent },
      { path: 'not-found', component: PageNotFoundComponent },
      { path: 'landing', component: LandingPageComponent },
      {
        path: 'Home',
        loadChildren: () =>
          import('./screens/home.module').then((m) => m.HomeModule),
        data: { preload: true }
      },
      {
        path: 'Dashboard',
        loadChildren: () =>
          import('./screens/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        data: { preload: true }
      },
      // {
      //   path: 'O3sm',
      //   loadChildren: () =>
      //     import('./o3-schedular/o3-schedular.module').then(
      //       (m) => m.O3SchedularModule
      //     ),
      // },
      {
        path: 'OLE',
        loadChildren: () => import('./OLE/ole.module').then((m) => m.OLEModule),
        data: { preload: true }
      },
      // {
      //   path: 'LossAnalysis',
      //   loadChildren: () =>
      //     import('./LossAnalysis/lossanalysis.module').then(
      //       (m) => m.LossAnalysisModule
      //     ),
      // },
      // {
      //   path: 'Access',
      //   loadChildren: () =>
      //     import('./Access/access.module').then((m) => m.AccessModule),
      // },
      {
        path: 'user-access',
        loadChildren: () =>
          import('./user-management/user-access-management.module').then((m) => m.UserManagementModule),
        data: { preload: true },
        runGuardsAndResolvers: 'paramsChange',
      },
      {
        path: 'PM',
        loadChildren: () => import('./PM/pm.module').then((m) => m.PmModule),
        data: { preload: true }
      },
      {
        path: 'at',
        loadChildren: () =>
          import('./analytical-tools/at.module').then((m) => m.AtModule),
        data: { preload: true }
      },
      // tslint:disable-next-line: max-line-length
      {
        path: 'ProgressiveMaintenance',
        loadChildren: () =>
          import(
            './Progressive Maintenance/progressiveMaintenance.module'
          ).then((m) => m.ProgressiveMaintenanceModule),
        data: { preload: true }
      },
      // {
      //   path: 'CIL',
      //   loadChildren: () => import('./CIL/cil.module').then((m) => m.CILModule),
      // },
      // {
      //   path: 'DMS',
      //   loadChildren: () => import('./DMS/dms.module').then((m) => m.DMSModule),
      // },
      {
        path: 'DT',
        loadChildren: () => import('./DT/dt.module').then((m) => m.DTModule),
        data: { preload: true }
      },
      // {
      //   path: 'KPI',
      //   loadChildren: () =>
      //     import('./KPIs Management/kpi.module').then((m) => m.KPIModule),
      // },
      // {
      //   path: 'DM',
      //   loadChildren: () =>
      //     import('./Document Management Components/documents.module').then(
      //       (m) => m.DocumentsModule
      //     ),
      // },
      {
        path: 'quality',
        loadChildren: () =>
          import('./qualitymanagement/qualitymanagement.module').then(
            (m) => m.QualitymanagementModule
          ),
        data: { preload: true },
        runGuardsAndResolvers: 'paramsChange',
      },
      {
        path: 'mes-lite-insights', loadChildren: () =>
          import('./mes-lite-insights/mes-lite-insights.module').then(
            (m) => m.MesLiteInsightsModule),
            
      },

      // tslint:disable-next-line: max-line-length
      // {
      //   path: 'PerformanceManagement',
      //   loadChildren: () =>
      //     import('./Performance Management/prmanagement.module').then(
      //       (m) => m.PerformanceManagementModule
      //     ),
      // },
      {
        path: 'Safety',
        loadChildren: () =>
          import('./safety/safety.module').then((m) => m.SafetyModule),
        data: { preload: true }
      },
      // {
      //   path: 'orp-dashboard',
      //   loadChildren: () =>
      //     import('./orp-dashboard/orp-dashboard.module').then(
      //       (m) => m.OrpDashboardModule
      //     ),
      // },
      // {
      //   path: 'opmsQuality',
      //   loadChildren: () =>
      //     import('./opms-quality/opms-quality.module').then(
      //       (m) => m.OpmsQualityModule
      //     ),
      // },
      {
        path: 'rawMaterial',
        loadChildren: () =>
          import('./raw-material/raw-material.module').then(
            (m) => m.RawMaterialModule
          ),
        data: { preload: true }
      },
      // {
      //   path: 'availbilityanalysis',
      //   component: AvailabilityAnalysisComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'cu-analysis',
      //   component: CuAnalysisComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'quality-analysis',
      //   component: QualityAnalysisComponent,
      //   canActivate: [AuthGuard],
      // },
      { path: 'dashboard', component: DashboardComponent },

      // { path: 'safety-db', component: SafetyDbComponent },
      // { path: 'quality-db', component: QualityDbComponent },
      // { path: 'defect-config', component: DefectConfigurationComponent },
      // { path: 'defect-management', component: DefectManagementMasterComponent },
      // { path: 'orgtree', component: OrgTreeComponent },
      // OPMS-Glass
      // { path: 'main', component: OPMSMainComponent },
      { path: 'qcBox', component: QCBoxComponent },

      { path: 'qaDataEntry', component: QaDataEntryComponent },
      {
        path: 'PestControl',
        loadChildren: () =>
          import('./Pest Control/pestControl.module').then(
            (m) => m.PestControlModule
          ),
        data: { preload: true }
      },

    ],
  },
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'signup', component: SignUpComponent },
      { path: 'forgotpassword', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: '', component: LoginComponent },
      { path: 'customer-complaint', component: CustomerComplaintComponent },
      {
        path: SharedConstants.ACCOUNT + '/' + SharedConstants.CONFIRM_EMAIL,
        component: ConfirmEmailComponent
      },
      { path: 'meeting-evaluation', component: MeetingEvaluationComponent },
      { path: 'date', component: DatetestComponent },
      {
        path: 'meeting-evaluation-level',
        component: MeetingEvaluationLevelComponent,
      },
      {
        path: 'NewSfdcHoney',
        component: NewSfdcHoneyComponent,
      },
      {
        path: 'NewSfdc',
        component: NewSfdcComponent,
      },
      {
        path: 'handsfree-operator',
        component: HandsfreeOperatorComponent,
      },
      {
        path: 'CustomerComplaint',
        loadChildren: () =>
          import('./CustomerCompalint/customercomplaint.module').then(
            (m) => m.CustomerComplaintModule
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'Home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', preloadingStrategy: CustomPreloadingStrategy })],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy]
})
export class AppRoutingModule { }
